:host {
    display: inherit;
    vertical-align: top;
    white-space: nowrap;

    c-icon {
        display: inline-block;
        height: 20px;
        width: 20px;
//        overflow: hidden;
        vertical-align: middle;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        line-height: 22px;
        font-size: 18px;
        padding-left: 10px;
        white-space: normal;
    }
}
:host(.not-trusted) {
    color: $color-bund-red;
    display: block;
    c-icon {
        color: $color-bund-red;
    }
}